import ScoringRequestDetails from './scoringRequestDetails';

export default ScoringRequestDetails;
